import { router } from '@inertiajs/react'
import { ReportDetail } from '@/components/reports/ReportDetail'
import type { Report } from '@/components/reports/types'

interface Props {
  report: Report
}

export default function ReportsShow({ report }: Props) {
  const handleBack = () => {
    router.visit('/reports')
  }

  const handleShare = () => {
    // Copy report URL to clipboard
    const url = window.location.href
    navigator.clipboard.writeText(url)
    alert('Report link copied to clipboard!')
  }

  const handleExport = () => {
    window.location.href = `/reports/${report.id}/export`
  }

  const handleRegenerate = () => {
    if (confirm('Are you sure you want to regenerate this report? This will re-analyze the items.')) {
      router.post(`/reports/${report.id}/regenerate`)
    }
  }

  const handleDelete = () => {
    if (confirm('Are you sure you want to delete this report?')) {
      router.delete(`/reports/${report.id}`)
    }
  }

  const handleViewItems = () => {
    router.visit(`/items?report_id=${report.id}`)
  }

  const handleAddComment = (message: string) => {
    router.post(`/reports/${report.id}/comments`, {
      comment: { message }
    })
  }

  const handleEditComment = (commentId: string, message: string) => {
    router.patch(`/comments/${commentId}`, {
      comment: { message }
    })
  }

  const handleDeleteComment = (commentId: string) => {
    router.delete(`/comments/${commentId}`)
  }

  const handleViewGem = (itemId: string) => {
    router.visit(`/items/${itemId}`)
  }

  const handleRefresh = () => {
    router.reload()
  }

  const handleViewAllGems = () => {
    router.visit(`/streams/${report.streamId}/gems`)
  }

  const handleSendEmail = async () => {
    if (!confirm('Send this report to all stream subscribers?')) {
      return
    }

    try {
      const response = await fetch(`/reports/${report.id}/send_email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
        },
      })

      const data = await response.json()

      if (response.ok) {
        alert(data.message)
        router.reload()
      } else {
        alert(data.error || 'Failed to send email')
      }
    } catch (error) {
      alert('Failed to send email')
    }
  }

  return (
    <ReportDetail
      report={report}
      onBack={handleBack}
      onShare={handleShare}
      onExport={handleExport}
      onRegenerate={handleRegenerate}
      onDelete={handleDelete}
      onViewItems={handleViewItems}
      onAddComment={handleAddComment}
      onEditComment={handleEditComment}
      onDeleteComment={handleDeleteComment}
      onViewGem={handleViewGem}
      onRefresh={handleRefresh}
      onViewAllGems={handleViewAllGems}
      onSendEmail={handleSendEmail}
    />
  )
}
